import { bl_sfa_source_hdr_RowClass } from "../../dbschema/bl_sfa_source_hdr.model";
import { BaseContainerModel } from "../base-container.model";

export class SfaSourceHdrContainerModel extends BaseContainerModel {
	bl_sfa_source_hdr: bl_sfa_source_hdr_RowClass =
		new bl_sfa_source_hdr_RowClass();
}
